import update from "immutability-helper";
import type { AnyAction } from "redux";
import type { PrepSessionListItem } from "@theirstory/common/api_types/backend";

import { PREPSESSIONS_LOADED } from "../actions/types";

export interface PrepSessionsState {
  prepsessions: PrepSessionListItem[];
  paging: {
    size: number;
    current: number;
    totalItems: number;
  };
  loaded: boolean;
}

const initialState: PrepSessionsState = {
  prepsessions: [],
  paging: {
    size: 15,
    current: 1,
    totalItems: 0,
  },
  loaded: false,
};

const prepSessionsReducer = (state = initialState, { type, payload }: AnyAction) => {
  switch (type) {
    case PREPSESSIONS_LOADED: {
      return update(state, {
        prepsessions: { $set: payload.prepsessions },
        paging: {
          current: { $set: payload.page },
          totalItems: { $set: payload.total },
        },
        loaded: { $set: true },
      });
    }
    default:
      return state;
  }
};

export default prepSessionsReducer;
